import { combineReducers } from "@reduxjs/toolkit";
import routeLogin from "./route-login";
import connection from "./connection";
import addCargo from "./add-cargo";
import version from "./version";
import driverLocation from "./driver-location";
import apiKeys from "./api-keys";
import time from "./time";
import notifications from "./notifications";
import network from "./network";
import nativeVersion from "./native-version";
import cargoTimeTracking from "./cargo-time-tracking";
import cargoTypes from "./cargo-types";
import errorToast from "./error-toast";

export default combineReducers({
  routeLogin,
  connection,
  addCargo,
  version,
  driverLocation,
  apiKeys,
  time,
  notifications,
  network,
  nativeVersion,
  cargoTimeTracking,
  cargoTypes,
  errorToast,
});
